import React from 'react';
import ReactDOM from 'react-dom/client';
// Composants
import App from './App';
import ErrorBoundary from './components/Utils/ErrorBoundary';
// Redux
import { legacy_createStore as createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import { thunk } from 'redux-thunk';
import rootReducer from './reducers';
// Semantic UI
import 'semantic-ui-css/semantic.min.css';
// Styles
import './styles/index.css';

//? Importé par index.js une fois la langue chargée. Garder l'ordre des imports : il fixe l'ordre des feuilles de style
//? (les styles des composants d'App, puis Semantic UI, puis index.css)

const middleware = [thunk];
const store = createStore(rootReducer, applyMiddleware(...middleware));

ReactDOM.createRoot(document.getElementById("root")).render(
    <Provider store={store}>
        <ErrorBoundary isGlobal={true}>
            <App />
        </ErrorBoundary>
    </Provider>
);
